import formatMessage from 'format-message';

import { ACTION_ADD_DIALOG, ACTION_REMOVE_DIALOG, ACTION_DIALOG_NOTHING } from '../constants/dialog';
import { dispatch } from '../store';

let dialogCounter = 1;

const getNextDialogId = () => {
  dialogCounter += 1;
  return dialogCounter;
};

const cancelDefaults = (withCancel, onCancel, cancelText) => {
  if (withCancel === undefined) {
    withCancel = true;
  }

  if (withCancel) {
    if (onCancel === undefined) {
      onCancel = { type: ACTION_DIALOG_NOTHING, payload: {} };
    }
    if (cancelText === undefined) {
      cancelText = formatMessage('Cancel');
    }
  } else {
    onCancel = null;
    cancelText = null;
  }
  return [withCancel, onCancel, cancelText];
};

export const addDialog = ({
  id,
  title,
  message,
  onConfirm, // should be an action object or a function
  confirmText,
  withCancel,
  onCancel, // should be an action object or a function or not defined if withCancel is false
  cancelText
}) => {
  if (id === undefined) {
    id = getNextDialogId();
  }

  [withCancel, onCancel, cancelText] = cancelDefaults(withCancel, onCancel, cancelText);

  const label = (withCancel)
    ? formatMessage('Confirmation')
    : formatMessage('Please acknowledge');

  return dispatch({
    type: ACTION_ADD_DIALOG,
    payload: {
      id,
      title,
      message,
      onConfirm,
      confirmText,
      onCancel,
      cancelText,
      withCancel,
      label
    },
  });
};

export const removeDialog = id => dispatch({
  type: ACTION_REMOVE_DIALOG,
  payload: { id }
});

export const removeAllDialogs = () => dispatch({
  type: ACTION_REMOVE_DIALOG,
  payload: { id: null }
});

export const addLoginDialog = () => addDialog({
  title: formatMessage('Login required'),
  message: formatMessage('You are currently not signed in. To use this function, please log in via your Canvas account.'),
  confirmText: formatMessage('Ok'),
  confirmAction: null,
  withCancel: false
});
